import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import faqsData from "../data/faqs.json";

export default function Faq() {
  const [openFaqs, setOpenFaqs] = useState({});

  const toggleFaq = (id) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>FAQs | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="faq" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Preguntas frecuentes</h1>
          <p className="subtitle">Una lista de las preguntas más frecuentes, si te surge alguna duda que no esté en esta página, no dudes en ponerte en contacto con nosotros.</p>
        </div>
        <div className="content-main">
          {faqsData.map((faq) => {
            const isOpen = openFaqs[faq.id] || false;
            return (
              <div key={faq.id} className="category-wrapper">
                <div className={`category toggle ${isOpen ? "" : "close"}`} onClick={() => toggleFaq(faq.id)} >
                  {faq.question}
                </div>
                <div className="items text" style={{ display: isOpen ? "block" : "none" }} >
                  {faq.answer.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </>
  );
}
